import * as Route from '../utils/serverRoutes';
import {
  transformResponseCollection,
  updateCollectionById,
  payloadToData,
} from '../utils/helpers';
import makeRequest from '../utils/makeRequest';

const uniqueSellingPoint = {
  state: {
    collection: [],
    uploading: false,
  },
  reducers: {
    fetchUniqueSellingPointsReducer(state, { collection }) {
      return { ...state, collection };
    },
    addUniqueSellingPointReducer(state, payload) {
      return {
        ...state,
        collection: [...state.collection, payload],
      };
    },
    updateUniqueSellingPointReducer(state, payload) {
      return {
        ...state,
        collection: updateCollectionById(state.collection, payload.id, payload),
      };
    },
    removeUniqueSellingPointReducer(state, { id }) {
      const collection = state.collection.filter((e) => e.id !== id);

      return { ...state, collection };
    },
    updateAttributeReducer(state, payload) {
      return { ...state, ...payload };
    },
  },
  effects: (dispatch) => ({
    fetchUniqueSellingPoints(bmcId) {
      dispatch.uniqueSellingPoint.updateAttributeReducer({ uploading: true });

      makeRequest({
        dispatch,
        url: Route.uniqueSellingPoints(bmcId),
        success: (response) => {
          dispatch.uniqueSellingPoint.fetchUniqueSellingPointsReducer({
            collection: transformResponseCollection(response.data.data),
          });
        },
        finish: () => {
          dispatch.uniqueSellingPoint.updateAttributeReducer({
            uploading: false,
          });
        },
      });
    },
    async addUniqueSellingPoint(payload, state) {
      makeRequest({
        dispatch,
        method: 'post',
        url: Route.uniqueSellingPoints(state.bmc.current.id),
      });
    },
    async updateUniqueSellingPoint(payload, state) {
      const data = payloadToData(payload);
      dispatch.uniqueSellingPoint.updateUniqueSellingPointReducer(data);

      makeRequest({
        dispatch,
        method: 'put',
        url: Route.uniqueSellingPoint(state.bmc.current.id, payload.id),
        data: { uniqueSellingPoint: data },
      });
    },
    async removeUniqueSellingPoint(payload, state) {
      makeRequest({
        dispatch,
        method: 'delete',
        url: Route.uniqueSellingPoint(state.bmc.current.id, payload.id),
      });
    },
  }),
};

export default uniqueSellingPoint;
